<template>
    <div v-if="pageLoader" class="no-data">
        <RotatingLoader :size="30" :speed="0.6" />
        <span>Loading Details...</span>
    </div>
    <div v-else class="create-pr-container">
        <div class="create-wrapper" :key="refreshkey">
            <div class="header" v-if="!isCompletedMsgHouse">
                <div class="header_box" v-if="!isfinalMsgHouseCompleted">
                    <button class="home-btn" @click="popupType = 'goHome'">
                        <img :src="require('@/assets/icons/home.svg')" alt="">
                    </button>
                </div>
                <div class="top_header_rename">
                    <span class="pr-title">{{ originalTitle }}</span>
                    <RenamePopup v-if="isEditing" :docName="originalTitle" :isEditing="isEditing"
                        @update-isEdit="isEditing = $event" @updated-prTitle="originalTitle = $event"
                        flowType="messageHouse" />
                    <button class="edit-btn" @click="editTitle">
                        <img :src="require('@/assets/icons/edit.svg')" />
                    </button>
                </div>
            </div>
            <div v-else class="header">
                <div class="header-left">
                    <button class="back-btn" @click="goback">
                        <img :src="require('@/assets/icons/back-arrow.svg')">
                    </button>
                    <span class="header-title">Message House Details</span>
                </div>

                <div class="header-right">
                    <a v-if="false" class="share-wrapper" :href="'mailto:' + shareUrl">
                        <div class="icon-wrapper">
                            <img :src="require('@/assets/icons/share.svg')"></img>
                            <p>Share</p>
                        </div>
                    </a>
                    <button class="share-wrapper download" :disabled="downloadLoader" @click="downloadMessageHouse()">
                        <v-progress-circular v-if="downloadLoader" indeterminate :size="18"
                            :width="2"></v-progress-circular>
                        <div v-else class="icon-wrapper">
                            <Svg :src="require('@/assets/icons/download.svg')" fill="white"></Svg>
                            <p>Download</p>
                        </div>
                    </button>
                </div>

            </div>
            <div v-if="isFinalPage == false" class="mid-container">
                <div class="input-brief-container row" v-if="inputBriefStatus === 'static'">
                    <div class="form-section">
                        <div class="form-header">
                            <h2>Input Brief</h2>
                        </div>
                        <v-form class="context-form" v-model="isFormValid" @submit.prevent v-if="staticQuestion">
                            <div class="label">{{ staticQuestion.inputBrief[0].question }}</div>
                            <div class="static-qn-container">
                                <div class="qn-header">
                                    <div class="header-left">
                                        <Svg height="22" :src="InfoIcon"></Svg>
                                        <p class="header-txt">Expert Input Guide</p>
                                    </div>
                                    <button class="dropdown" @click="isOpen = !isOpen">
                                        <Svg height="9" v-if="isOpen" width="12" :src="UpIcon"></Svg>
                                        <Svg height="9" v-else width="12" :src="DownIcon"></Svg>
                                    </button>
                                </div>
                                <div v-if="isOpen" class="qn-wrapper">
                                    <!-- <p class="header-txt">Need help? Answering these questions helps craft sharper narratives.</p> -->
                                    <div v-for="(question, index) in questions" class="question-wrapper">
                                        <p class="qn-txt">{{ question }}</p>
                                    </div>
                                </div>
                            </div>
                            <v-textarea v-model="staticQuestion.inputBrief[0].answer" :rules="fieldRules"
                                variant="outlined" density="compact"
                                placeholder="[Start by describing the problem, your approach, and the impact you want to create…]"
                                @input="validateInput"></v-textarea>
                        </v-form>
                    </div>
                </div>
            </div>
            <div class="final-message-house" v-else>
                <FinalMessageHouse v-if="isFinalPage" :isfinalMsgHouseCompleted="isfinalMsgHouseCompleted"
                    :isCompletedMsgHouse="isCompletedMsgHouse" :msgHouseId="msgHouseId" :modelValue="msgHouseData"
                    @update:isEditingFinalMsgHouse="isEditingFinalMsgHouse = $event" :key="refreshkey"
                    :title="originalTitle" @update-docTitle="originalTitle = $event" />
            </div>

            <div class="footer" v-if="isFinalPage == false">
                <div class="inner-footer">
                    <div class="footer-action">
                        <button class="delete-pr" @click="handleDeletePr" v-if="!compareMode">
                            <img :src="require('@/assets/icons/delete.svg')" />
                            <v-progress-circular v-if="deleteLoader" indeterminate :size="18"
                                :width="2"></v-progress-circular>
                        </button> &nbsp;&nbsp;&nbsp;
                    </div>
                    <div class="footer-btn">
                        <div class="footer-right">
                            <button class="generate-pr" @click="handleGenerateClick"
                                :disabled="isInputEmpty || pageLoader">
                                <p>Generate Key Message</p>
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <v-overlay v-if="isGenerate" :model-value="isGenerate" class="overlay" persistent="true">
        <RotatingLoader :size="30" :speed="0.6" />
        <span>Generating</span>
    </v-overlay>
    <CommonPopup v-if="showCommonPopup" :showCommonPopup="showCommonPopup" :popupType="popupType"
        @confirm-action="handlePopupConfirmation" />
    <ConfirmPopup v-if="confirmPopup" v-model="confirmPopup" :title="'Message House discarded'" :image="deleteImage"
        :type="'success'" />

</template>
<script>
import RenamePopup from '@/components/RenamePopup.vue';
import CommonPopup from '@/components/CommonPopup.vue';
import axiosInstance from '@/axiosInterceptor';
import { Eventbus } from '@/plugins/eventBus';
import FinalMessageHouse from '@/views/MessageHouse/FinalMessageHouse.vue';
import ConfirmPopup from '@/components/ConfirmPopup.vue';
import RotatingLoader from '@/components/CircularProgressBar.vue';
import { downloadPr } from '@/helper/downloadPr';
import InfoIcon from '@/assets/icons/clr-info-icon.svg';
import UpIcon from '@/assets/icons/up-icon.svg';
import DownIcon from '@/assets/icons/down-icon.svg';
import { ThemeSymbol } from 'vuetify/lib/composables/theme';

export default {
    name: 'GenerateMessageHouse',
    components: {
        CommonPopup,
        RenamePopup,
        FinalMessageHouse,
        ConfirmPopup,
        RotatingLoader
    },
    props: {
        modelValue: {
            type: Object
        },
    },
    data() {
        return {
            pageLoader: false,
            isGenerate: false,
            isFormValid: false,
            originalTitle: null,
            isOpen: true,
            refreshkey: 0,
            fieldRules: [
                (v) => !!v || 'This field is required'
            ],
            InfoIcon,
            showCommonPopup: false,
            downloadLoader: false,
            confirmPopup: false,
            popupType: null,
            deleteImage: require('@/assets/icons/delete_red.svg'),
            staticQuestion: {
                inputBrief: [{
                    question: "What’s the story you’re trying to tell?",
                    answer: ""
                }]
            },
            msgHouseId: null,
            msgHouseData: [],
            docTitle: null,
            isEditing: false,
            inputBriefStatus: 'static',
            isFinalPage: false,
            deleteLoader: false,
            isfinalMsgHouseCompleted: false,
            questions: [
                "What’s the single most important thing you need people to understand? State it clearly. This is the anchor for everything that follows.",
                "Next, provide a brief description of what you’re putting forward — a product, a project, or an idea. Keep it straightforward and focused.",
                "From there, we’ll organize your input into thematic categories that define your value proposition and sharpen your voice. The result is a set of core messages you can use with investors, media, customers, or shareholders."
            ],
            isCompletedMsgHouse: false,
            InfoIcon, UpIcon, DownIcon
        }
    },
    computed: {
        inputBrief: {
            get() {
                return this.modelValue;
            }
        },
        isInputEmpty() {
            return !this.staticQuestion.inputBrief[0].answer ||
                this.staticQuestion.inputBrief[0].answer.trim() === '';
        }
    },
    watch: {
        staticQuestion: {
            deep: true,
            handler(newValue) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    staticQues: newValue
                });
            }
        },
        isFormValid() {
            this.$emit('update:isFormValid', this.isFormValid);
        },
        popupType() {
            if (this.popupType) {
                this.showCommonPopup = true;
            }
        },
    },
    methods: {
        async getMessageHouseDetails(isFallback=false) {
            if(!isFallback) {
                this.pageLoader = true;
            }
            try {
                const response = await axiosInstance.get(`/messageHouse/${this.$route.params.msgHouseId}`);
                if (response.status === 200) {
                    const item = response.data.data;
                    this.originalTitle = item.msgHouseName;

                    if (typeof item.baseMsgHouse === 'string') {
                        // Handle HTML response
                        this.msgHouseData = {
                            baseMsgHouse: item.baseMsgHouse, // Pass HTML content directly
                            msgHouseName: item.msgHouseName,
                            msgHouseId: this.msgHouseId,
                            createdAt: item.createdOn,
                            updatedAt: item.completedBy,
                            createdBy: item.createdBy,
                            status: item.status
                        };
                    } else {
                        // Handle JSON response (original format)
                        this.msgHouseData = {
                            keyMessage: {
                                title: item.baseMsgHouse?.keyMessageTitle,
                                content: item.baseMsgHouse?.keyMessageContent
                            },
                            visuals: item.baseMsgHouse?.keyMessageData?.map(visual => ({
                                title: visual.title,
                                description: visual.content,
                                points: visual.proofPoints || []
                            })),
                            msgHouseName: item.msgHouseName,
                            msgHouseId: this.msgHouseId,
                            createdAt: item.createdOn,
                            updatedAt: item.completedBy,
                            createdBy: item.createdBy,
                            status: item.status
                        };
                    }

                    if (this.msgHouseData.status === 'COMPLETED') {
                        this.isFinalPage = true;
                        this.isCompletedMsgHouse = true;
                        this.isfinalMsgHouseCompleted = false;
                    }
                }
            } catch (error) {
                Eventbus.emit('commonSnackbar', {
                    snackType: 'error',
                    message: 'Error fetching message house details',
                });
            } finally {
                this.pageLoader = false;
            }
        },
        async handleGenerateClick() {
            this.isGenerate = true;
            
            try {
                let payload = {
                    inputBrief: this.staticQuestion.inputBrief[0].answer,
                    msgHouseId: this.msgHouseId,
                }

                let response = await axiosInstance.put('/messageHouse/generate', payload)

                if (response.status === 200) {
                    this.refreshkey +=1;

                    if (typeof response.data.data.keyMessageRefined === 'string') {
                        // Handle HTML response
                        this.msgHouseData = {
                            baseMsgHouse: response.data.data.keyMessageRefined, // Pass HTML content directly
                            msgHouseName: this.originalTitle,
                            msgHouseId: this.msgHouseId,
                            createdAt: response.data.data.createdOn,
                            updatedAt: response.data.data.completedBy,
                            createdBy: response.data.data.userName,
                            status: response.data.data.status
                        };
                    } else {
                        // Handle JSON response (original format)
                        this.msgHouseData = {
                            keyMessage: {
                                title: response.data.data.keyMessageRefined?.keyMessageTitle,
                                content: response.data.data.keyMessageRefined?.keyMessageContent
                            },
                            visuals: response.data.data.keyMessageRefined?.keyMessageData.map(item => ({
                                title: item.title,
                                description: item.content,
                                points: item.proofPoints
                            })),
                            msgHouseName: this.originalTitle,
                            msgHouseId: this.msgHouseId,
                            createdAt: response.data.data.createdOn,
                            updatedAt: response.data.data.completedBy,
                            createdBy: response.data.data.userName,
                            status: response.data.data.status
                        };
                    }

                    this.isFinalPage = true;
                    this.isfinalMsgHouseCompleted = true;
                    this.isCompletedMsgHouse = false;
                }



            } catch (error) {
                console.error("Error generating PR Strategy", error);
                if (error.response?.status === 504 || error.code === 'ERR_NETWORK') {
                    let attempts = 0;
                    let maxAttempts = 40;
                    const intervalTime = 15000;
                    const intervalId = setInterval(async () => {
                        attempts++;
                        try {
                            let isFallback = true;
                            await this.getMessageHouseDetails(isFallback);
                            if (this.msgHouseData.status === "COMPLETED") {
                                clearInterval(intervalId);
                                this.msgHouseData = plan;
                                this.isFinalPage = true;
                                this.isfinalMsgHouseCompleted = true;
                                return;

                            } else if (attempts >= maxAttempts) {
                                clearInterval(intervalId);
                                Eventbus.emit('commonSnackbar', {
                                    snackType: 'warning',
                                    message: 'Message House generation is taking longer than expected. Please check again later.',
                                });
                            }
                        } catch (pollError) {
                            console.error("Error during polling:", pollError);
                            clearInterval(intervalId);
                            Eventbus.emit('commonSnackbar', {
                                snackType: 'error',
                                message: 'Failed to generate Message House. Please try again later.',
                            });

                        }
                    }, intervalTime);
                }

            } finally {
                this.isGenerate = false;
                this.refreshkey +=1;
            }
        },
        validateInput() {
            this.isFormValid = !this.isInputEmpty;
        },
        goback() {
            this.$router.go(-1);
        },
        editTitle() {
            this.isEditing = true;
        },
        handleDeletePr() {
            this.popupType = 'delete'
            this.showCommonPopup = true;
        },
        handleTitle(newTitle) {
            this.originalTitle = newTitle;
        },
        async downloadMessageHouse() {
            this.downloadLoader = true;
            let payload = {
                msgHouseId: this.msgHouseId,
                flowType: "MESSAGEHOUSE"
            }
            await downloadPr(payload, this.originalTitle || this.msgHouseData.msgHouseName);
            this.downloadLoader = false;
        },
        async handlePopupConfirmation(val) {
            this.showCommonPopup = false;
            if (val === 'yes') {
                if (this.popupType === 'delete') {
                    this.deleteLoader = true;
                    axiosInstance.put('/messageHouse/delete', { msgHouseId: this.$route.params.msgHouseId, })
                        .then((response) => {

                            if (response.status === 204) {
                                this.confirmPopup = true;
                                setTimeout(() => {
                                    this.$router.push({ name: 'MessageHouseHome' });
                                }, 1000);
                            }
                        })
                        .catch((error) => {
                            console.error('Error while deleting PR', error);
                            Eventbus.emit('commonSnackbar', {
                                snackType: "failed",
                                message: 'Failed to delete PR'
                            });
                        })
                        .finally(() => {
                            this.deleteLoader = false;
                        })
                }
                else {
                    this.$router.push({ name: 'MessageHouseHome' });
                }
            }
            this.popupType = null;
        },

    },
    async mounted() {
        this.msgHouseId = this.$route.params.msgHouseId;
        await this.getMessageHouseDetails();
        if (this.msgHouseData.status === 'COMPLETED') {
            this.isFinalPage = true;
            this.isCompletedMsgHouse = true;
            this.isfinalMsgHouseCompleted = false;
        }

    }
}
</script>
<style scoped>
.no-data {
    width: 100%;
    height: 100%;
    padding: 2rem;
    gap: 20px;
    display: flex;
    overflow: auto;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
}

.create-pr-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: var(--dark-background);
    background-size: 100% 100%;
}

.create-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: var(--dark-background);
    background-size: 100% 100%;
}

.row {
    align-items: center;
    padding: 2rem 4rem;
}

.header {
    position: sticky;
    top: 0;
    right: 0;
    left: 0;
    padding: 0.5rem 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFFFFF09;
    border-bottom: 1px solid #FFFFFF33;
    color: white;
    z-index: 100;
}

.header-left {
    display: flex;
    flex-direction: row;
    gap: 0.75rem;
    justify-content: center;
    align-items: center;
}

.header-txt {
    display: flex;
    align-items: center;
}

.back-btn {
    height: 2.5rem;
    width: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1em;
    background-color: #FFFFFF;
    border: 1px solid #E5E5E5;
    border-radius: 50%;
}

.header-title {
    font-size: 18px;
    font-weight: 500;
    justify-content: center;
    align-items: center;
    display: flex;
}

.dropdown {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 1.8rem;
    height: 1.8rem;
    background: #FFFFFF;
    border: 1px solid #d4d4d4;
    border-radius: 0.5rem;
}

.header-right {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    padding: 12px;
}

.share-wrapper {
    all: unset;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 12px 8px 12px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
}

.icon-wrapper {
    display: flex;
    align-items: center;
    gap: 0.5em;
    cursor: pointer;
}

.download {
    background: linear-gradient(90deg, #FF00C3, #FF0A19, #FF7800);
    color: #FFFFFF;
}

.final-pr-header {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    padding: 0px 30px;
}

.pr-title {
    font-weight: 500;
    text-align: center;
}

.edit-title-input {
    width: 200px;
    align-items: center;
}

.edit-btn {
    display: flex;
    padding: 8px 8px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
    align-items: center;
    cursor: pointer;
    margin: 10px 5px;
}

.delete-pr {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
}

.overlay {
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    z-index: 9999;
}

.home-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFF1F;
    border-radius: 8px;
    padding: 12px;

}

.header_box {
    width: 5%;
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.top_header_rename {
    width: 95%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.generate-pr {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 40px;
    gap: 8px;
    border-radius: 8px;
    opacity: 0.8;
    background: var(--primary-gradient-with-black)
}

.final-message-house {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    justify-content: center;
    align-items: center;
    overflow-y: auto;
    will-change: transform;
    scrollbar-width: thin;
}

.footer-right {
    display: flex;
    gap: 12px;
    align-items: center;
}

.footer {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px 48px;
    background: #180914;
    border-top: 1px solid #FFFFFF33;
    color: white;
    z-index: 100;
}

.footer--disabled {
    pointer-events: none;
    opacity: 0.5;
    filter: grayscale(0.8);
}

.inner-footer {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.footer-action {
    display: flex;
    flex-direction: row;
    width: 50%;
}

.footer-btn {
    width: 50%;
    max-width: 1024px;
    display: flex;
    justify-content: flex-end;
}

.mid-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    scrollbar-width: thin;
    will-change: transform;
}

.input-brief-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    flex: 1;
}

.row {
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    padding: 2rem 4rem;
}

.static-qn-container {
    display: flex;
    flex-direction: column;
    font-weight: 600;
    color: var(--dark-grey-color);
    border-radius: 8px;
    height: fit-content;
    overflow: hidden;
    border: 1px solid #E5E5E5;
}

.qn-header {
    display: flex;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    background: #EEEEEE;
    align-items: center;
    justify-content: space-between;
}

.qn-wrapper {
    display: flex;
    flex-direction: column;
    padding: 1rem 1.25rem;
    gap: 0.5rem;
    background-color: #F5F5F5;
    border-top: 1px solid #E5E5E5;
}

.qn-txt {
    color: #737373;
    font-weight: 400;
    font-size: 14px;
}

.form-section {
    width: 80%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    flex: 1;
    padding: 0px 0px 0px 200px;

}

.form-header {
    border-radius: 8px 8px 0 0;
}

.form-header h2 {
    color: white;
    font-size: 20px;
    font-weight: 500;
}

.context-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 2rem;
    border-radius: 12px;
    background: #FAFAFA;
    width: 85%;
    flex: 1;
}

.label {
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    color: #171717;
}
</style>